var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  // console.log(links[i].hostname);
  if(links[i].hostname != ""){
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}
  
function matchheight() {
  /*jQuery(".card .card-product").matchHeight();*/
  jQuery(".product a.card-title").matchHeight();
  jQuery(".card-information .apaylater-widget").matchHeight();
  jQuery(".collection-list-item .img-box").matchHeight();
  
}


$(document).ready(function() {
  matchheight();
 
 
  
  if(window.location.hash == '#recover'){
    $("html, body").animate({ scrollTop: 100 }, "slow");
  }
  $('.forget-password,.cancel').click(function(){
    $("html, body").animate({ scrollTop: 100 }, "slow");
  }); 

   $(".section-header-navigation").removeClass("shopify-section-header-sticky");
  
  $(".cst-menu-vertical .cst-menu-hamburg").click(function() {
    $('html').addClass("cst-menu-open");
  });
  $(".header__inline-menu .cst-menu-close").click(function() {
    $('html').removeClass("cst-menu-open");
  });

  $(".cst-menu-sticky-vertical .cst-menu-hamburg").click(function() {
    $('html').addClass("cst-menu-sticky-open");
  });
  $(".header__inline-menu .cst-menu-close").click(function() {
    $('html').removeClass("cst-menu-sticky-open");
  });
  
  $("nav .menu-lv-item.dropdown .cst-icon-dropdown").click(function() {
    $(this).parents('li').toggleClass("is-open");
    $(this).next('ul').toggleClass("is-open");
  });  
  
  jQuery(document).on("click", "toolbar-item .toolbar-wrapper .toolbar-item, .pagination-wrapper nav a, #main-collection-filters .sidebarBlock .facets__list, #CollectionFiltersForm .facets__clear-all, #CollectionFiltersForm facet-remove a.js-facet-remove, #CollectionFiltersForm price-range", function(event2) {
    console.log("filter1");
    setTimeout(function() {
      matchheight();      
    }, 1500);
  });
});

$(window).on("load", function () {    
  matchheight(); 
  setTimeout(function() {
    matchheight();      
  }, 500);
});

// const timeID = setInterval(matchheight, 1500);